export const expertsSection = {
  kicker: 'Экспертиза',
  title: 'Эксперты индустрии',
  description: ['Мы постоянно увеличиваем список тем и', 'экспертов, следите за изменениями.'],
  experts: [
    {
      name: 'Андрей Заворин',
      company: 'Профессор Банковской Финансовой Академии Республики Узбекистан',
      topic: 'Искусственный интеллект на службе инвестиционных фондов',
      imageSrc: '/images/expert-photo-zavorin.jpg',
      href: '/topic-ai-investments'
    },
    {
      name: 'Светлана Федорова',
      company: [
        'Создатель и руководитель Академии РИМ',
        'Председатель комитета по IT и ИИ в Деловой России г. Новосибирска',
        'Руководитель департамента по работе с субъектами РФ Ассоциации инновационных решений и искусственного интеллекта «Регионы XXI век»'
      ],
      topic: 'Кейсы внедрения ИИ (отраслевые практики)',
      imageSrc: '/images/expert-photo-svetlana-fedorova.png',
      href: '/topic-ai-cases'
    },
    {
      name: 'Татьяна Заворина',
      company: 'Действующий HRD в fintech',
      topic: 'ИИ-трансформация. Почему это не про технологии, а про людей',
      imageSrc: '/images/topic-photo-tatyana-zavorina.png',
      href: '/topic-ai-transformation'
    },
    {
      name: 'Александр Ковригин',
      company: 'Основатель бизнес-клуба DAO',
      topic: 'От промптов к командам ИИ-агентов: как построить бизнес, который работает, пока вы спите',
      imageSrc: '/images/expert-photo-alexander-kovrigin.png',
      imagePosition: 'center top',
      href: '/topic-ai-assistants'
    },
    {
      name: 'Нина Мазур',
      company: 'Амбассадор AI от Сбер',
      topic: 'От экспериментов к системе: как крупный бизнес внедряет искусственный интеллект',
      imageSrc: '/images/topic-photo-nina-mazur.png',
      imagePosition: 'center top',
      href: '/topic-ai-enterprise'
    },
    {
      name: 'Алексей Зеленин',
      company: 'Предприниматель и сооснователь Lexis Voice',
      topic: 'ИИ НЕ ЗАМЕНИТ МЕНЕДЖЕРОВ, но заменит слабое обучение: как бизнесу тренировать продажи, сервис и коммуникации на реальных сценариях',
      imageSrc: '/images/expert-photo-alexey-zelenin.jpg',
      href: '/topic-ai-sales-training'
    }
  ]
};
